import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import {
  CardContainer,
  CardEyebrow,
  CardImg,
  CardTextBlock,
  CardTitle,
  ImgCover,
} from 'components/Cards/VideoCard/styled'
import { DeleteOutlineOutlined } from '@mui/icons-material'
import { Load } from 'ui/styled'
import { buildFavoriteDragId } from '../utils'
import {
  CardActionBar,
  CardActionButton,
  CardSelection,
  DraggableCard,
  SelectionInput,
} from '../styled'
import { CardSlot } from './styled'
import AudienceAccessIndicators from 'components/AudienceAccessIndicators'
import { getContentAudiences } from 'utils/audienceAccess'

export default function FavoriteCard({
  item,
  selected,
  onSelect,
  onOpen,
  onRemove,
  busy,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: buildFavoriteDragId(item.favoriteId),
    data: {
      type: 'item',
      favoriteId: item.favoriteId,
      folderId: item.folderId,
    },
    disabled: busy,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <CardSlot>
      <DraggableCard ref={setNodeRef} style={style} dragging={isDragging} selected={selected}>
        <CardSelection onClick={(event) => event.stopPropagation()}>
          <SelectionInput
            type="checkbox"
            checked={selected}
            onChange={() => onSelect(item.favoriteId)}
          />
        </CardSelection>
        <CardActionBar onClick={(event) => event.stopPropagation()}>
          <CardActionButton type="button" onClick={() => onRemove(item.favoriteId)} disabled={busy}>
            {busy ? <Load /> : <DeleteOutlineOutlined fontSize="small" />}
          </CardActionButton>
        </CardActionBar>
        <CardContainer fullWidth onClick={() => onOpen(item)} {...attributes} {...listeners}>
          <CardImg course={item?.type === 'courses' || item?.type === 'partners-and-staffs'}>
            <ImgCover
              src={item?.image?.url || item?.cover || '/images/image.png'}
              alt={item?.title}
              draggable={false}
            />
            {item?.type === 'courses' ? null : (
              <AudienceAccessIndicators audiences={getContentAudiences(item)} />
            )}
          </CardImg>
          <CardTextBlock>
            {item?.type ? <CardEyebrow>{item.type.replaceAll('-', ' ')}</CardEyebrow> : null}
            <CardTitle>{item?.title}</CardTitle>
          </CardTextBlock>
        </CardContainer>
      </DraggableCard>
    </CardSlot>
  )
}
